/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import React, { useContext, useEffect, useState } from "react";
import LoadingIndicator from "../../Components/LoadingIndicator";
import { environment } from "../../environment";
import { translationKeys, useTranslation } from "../../Internationalisierung/i18nBasis";
import AuthenticationClient from "../AuthenticationClient";
import { useAuthenticationContext } from "../AuthenticationContext";

export interface IstMandantGueltigContextProps {
    children: React.ReactNode;
}

const istMandantGueltigContext = React.createContext<boolean>(false);
export function useIstMandantGueltigContext(): boolean {
    return useContext(istMandantGueltigContext);
}

export default function IstMandantGueltigContext(props: IstMandantGueltigContextProps) {
    const authenticationContext = useAuthenticationContext();
    const isLoggedIn = authenticationContext?.isLoggedIn;
    const { mandant, isSystem } = environment;
    const [istMandantGueltig, setIstMandantGueltig] = useState(false);
    const authenticationClient = new AuthenticationClient();
    const { t } = useTranslation();

    function navigiereAufErsteMandantUrl(authenticationClient: AuthenticationClient) {
        authenticationClient.ermittleRelativeErsteMandantUrl().then((relativeErsteMandantUrl) => {
            if (relativeErsteMandantUrl) {
                window.location.replace(environment.baseUrl + relativeErsteMandantUrl);
            } else {
                window.location.replace(environment.infoUrl(t(translationKeys.istMandantGueltigKontext.keinMandant)));
            }
        });
    }

    useEffect(() => {
        if (isSystem) {
            setIstMandantGueltig(true);
            return;
        }

        if (mandant) {
            authenticationClient.istMandantGueltig(mandant).then(istMandantGueltig => {
                if (isLoggedIn && !istMandantGueltig) {
                    navigiereAufErsteMandantUrl(authenticationClient);
                } else if (!istMandantGueltig) {
                    window.location.replace(environment.infoUrl(t(translationKeys.istMandantGueltigKontext.mandantUngueltig)));
                } else {
                    setIstMandantGueltig(true);
                }
            })
        } else {
            navigiereAufErsteMandantUrl(authenticationClient);
        }
    }, [mandant, isSystem]);

    return (
        <istMandantGueltigContext.Provider value={istMandantGueltig} >
            <LoadingIndicator loading={!istMandantGueltig}>
                {props.children}
            </LoadingIndicator>
        </istMandantGueltigContext.Provider>
    );
}
